import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import IndustrialTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import industrialIcon from "../../../../../assets/design-revamp-company/category-icons/industrial_gas_icon.svg";
const IndustrialContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="emission-gas-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("INDUSTRIAL_GAS_INPUTS")}
          isNormal={true}
          number={"3.2"}
          icon={industrialIcon}
        />
      </div>
      {showTable && <IndustrialTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default IndustrialContents;
